export enum LogLevel {
  DEBUG = 1,
  INFO,
  WARN,
  ERROR,
  FATAL,
}

const getLogLevel = (env: string | undefined) => {
  switch (env) {
    case 'production':
      return 4;
    case 'development':
      return 1;
    default:
      return 1;
  }
};

const logLevel = getLogLevel(process.env.APP_ENV);

export default class Logger {
  static debug(...args: [any?, ...any[]]) {
    if (logLevel <= LogLevel.DEBUG) {
      args.unshift('[DEBUG]');
      console.debug(...args); // eslint-disable-line no-console
    }
  }

  static info(...args: [any?, ...any[]]) {
    if (logLevel <= LogLevel.INFO) {
      args.unshift('[INFO]');
      console.info(...args); // eslint-disable-line no-console
    }
  }

  static warn(...args: [any?, ...any[]]) {
    if (logLevel <= LogLevel.WARN) {
      args.unshift('[WARN]');
      console.warn(...args); // eslint-disable-line no-console
    }
  }

  static error(...args: [any?, ...any[]]) {
    if (logLevel <= LogLevel.ERROR) {
      args.unshift('[ERROR]');
      console.error(...args); // eslint-disable-line no-console
    }
  }

  static fatal(...args: [any?, ...any[]]) {
    if (logLevel <= LogLevel.FATAL) {
      args.unshift('[FATAL]');
      console.error(...args); // eslint-disable-line no-console
    }
  }
}
